import type { AvailablePaymentMethod } from '~/modules/GraphQL/types';

export enum PayuMethodCodesEnum {
  PAYU_GATEWAY_BLIK = 'payu_gateway_blik',
  CASH_ON_DELIVERY = 'cashondelivery',
  BANK_TRANSFER = 'banktransfer',
  PAYU_GATEWAY = 'payu_gateway',
  PAYU_GATEWAY_CARD = 'payu_gateway_card',
}

export function getMethodCode(method: AvailablePaymentMethod) {
  if (method.code === PayuMethodCodesEnum.PAYU_GATEWAY_BLIK) return method.code;
  return (method?.payu_additional_data?.payu_method
    ? `${method.code}--${method.payu_additional_data.payu_method}`
    : method.code);
}
